/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import { CashBoxAuditHistoryDto, CashBoxAuditHistoryQueryParams } from '../../../api/cashBoxes/cashBoxesClient.typings';
import { Notification } from '../../../../utils/utils';
import { PeriodQueryParams } from '../../../api/apiCommon.typings';

export enum CashBoxAuditTabActionType {
    EXIT_CASHBOX_AUDIT_TAB = 'CashBoxAuditTab/ exit tab',
    FETCH_CASHBOX_AUDIT_HISTORY = 'CashBoxAuditTab/ fetch audit history start',
    FETCH_CASHBOX_AUDIT_HISTORY_SUCCESS = 'CashBoxAuditTab/ fetch audit history success',
    FETCH_CASHBOX_AUDIT_HISTORY_ERROR = 'CashBoxAuditTab/ fetch audit history error',
    DOWNLOAD_AUDIT_HISTORY = 'CashBoxAuditTab/ download audit history as excel start',
    DOWNLOAD_AUDIT_HISTORY_SUCCESS = 'CashBoxAuditTab/ download audit history as excel success',
    DOWNLOAD_AUDIT_HISTORY_ERROR = 'CashBoxAuditTab/ download audit history as excel error',
}

export const exitCashBoxAuditTabAction = () => createAction(CashBoxAuditTabActionType.EXIT_CASHBOX_AUDIT_TAB);

export const fetchCashBoxAuditHistoryAction = (params: CashBoxAuditHistoryQueryParams) =>
    createAction(CashBoxAuditTabActionType.FETCH_CASHBOX_AUDIT_HISTORY, params);

export const fetchCashBoxAuditHistorySuccessAction = (payload: CashBoxAuditHistoryDto) =>
    createAction(CashBoxAuditTabActionType.FETCH_CASHBOX_AUDIT_HISTORY_SUCCESS, payload);

export const fetchCashBoxAuditHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxAuditTabActionType.FETCH_CASHBOX_AUDIT_HISTORY_ERROR, { notification });

export const downloadAuditHistoryAction = (params: PeriodQueryParams) =>
    createAction(CashBoxAuditTabActionType.DOWNLOAD_AUDIT_HISTORY, params);

export const downloadAuditHistorySuccessAction = () =>
    createAction(CashBoxAuditTabActionType.DOWNLOAD_AUDIT_HISTORY_SUCCESS);

export const downloadAuditHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxAuditTabActionType.DOWNLOAD_AUDIT_HISTORY_ERROR, { notification });

export type CashBoxAuditTabAction =
    | ReturnType<typeof exitCashBoxAuditTabAction>
    | ReturnType<typeof fetchCashBoxAuditHistoryAction>
    | ReturnType<typeof fetchCashBoxAuditHistorySuccessAction>
    | ReturnType<typeof fetchCashBoxAuditHistoryErrorAction>
    | ReturnType<typeof downloadAuditHistoryAction>
    | ReturnType<typeof downloadAuditHistorySuccessAction>
    | ReturnType<typeof downloadAuditHistoryErrorAction>;
